import React from "react";
import { Phone, Mail, MapPin, Facebook, Instagram } from "lucide-react";
import { services, contactInfo } from "../mock";

const Footer = () => {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer className="bg-brand-dark border-t border-white/10">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div>
            <div className="mb-6">
              <img
                src="https://customer-assets-gfyr7b9c.emergentagent.net/job_design-build-live-1/artifacts/pt3xqgqe_file_000000007bb48210bf689d869ac39baf_GEoBTL.png"
                alt="KJ Ground Force"
                className="h-20 w-auto object-contain drop-shadow-lg"
              />
            </div>
            <p className="text-gray-400 text-sm leading-relaxed mb-6">
              Professional groundworks and landscaping services across the East Midlands. Reliable, quality-focused work you can trust.
            </p>
            <div className="flex gap-3">
              <a
                href="#"
                className="w-10 h-10 border border-white/10 rounded-md flex items-center justify-center text-gray-400 hover:bg-brand-yellow hover:text-brand-dark hover:border-brand-yellow transition-colors"
              >
                <Facebook size={16} />
              </a>
              <a
                href="#"
                className="w-10 h-10 border border-white/10 rounded-md flex items-center justify-center text-gray-400 hover:bg-brand-yellow hover:text-brand-dark hover:border-brand-yellow transition-colors"
              >
                <Instagram size={16} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-display text-white text-lg tracking-wide mb-5">
              QUICK LINKS
            </h4>
            <ul className="space-y-3">
              {[
                { label: "Home", id: "home" },
                { label: "About Us", id: "about" },
                { label: "Services", id: "services" },
                { label: "Projects", id: "projects" },
                { label: "Reviews", id: "reviews" },
                { label: "Contact", id: "contact" },
              ].map((l) => (
                <li key={l.id}>
                  <button
                    onClick={() => scrollTo(l.id)}
                    className="text-gray-400 text-sm hover:text-brand-yellow transition-colors"
                  >
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-display text-white text-lg tracking-wide mb-5">
              OUR SERVICES
            </h4>
            <ul className="space-y-3">
              {services.map((s) => (
                <li key={s.id}>
                  <button
                    onClick={() => scrollTo("services")}
                    className="text-gray-400 text-sm hover:text-brand-yellow transition-colors text-left"
                  >
                    {s.title.charAt(0) + s.title.slice(1).toLowerCase()}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-display text-white text-lg tracking-wide mb-5">
              CONTACT INFO
            </h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <Phone className="text-brand-yellow shrink-0 mt-0.5" size={16} />
                <a
                  href={`tel:${contactInfo.phone.replace(/\s/g, "")}`}
                  className="text-gray-400 text-sm hover:text-brand-yellow transition-colors"
                >
                  {contactInfo.phone}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="text-brand-yellow shrink-0 mt-0.5" size={16} />
                <a
                  href={`mailto:${contactInfo.email}`}
                  className="text-gray-400 text-sm hover:text-brand-yellow transition-colors break-all"
                >
                  {contactInfo.email}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="text-brand-yellow shrink-0 mt-0.5" size={16} />
                <span className="text-gray-400 text-sm">
                  Derbyshire, Nottinghamshire &amp; Leicestershire
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-6 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-gray-500 text-xs">
            © {new Date().getFullYear()} KJ Ground Force. All rights reserved.
          </p>
          <p className="text-gray-500 text-xs">
            Built with care for quality work.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
